import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, LogOut, Menu, X, Search } from "lucide-react";
import { useState } from "react";
import { useCart } from "../lib/cart";
import { isLoggedIn, getRole, clearAuth } from "../lib/auth";
import Logo from "./Logo";

export default function Header() {
  const navigate = useNavigate();
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const role = getRole();

  const logout = () => {
    clearAuth();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-black/85 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Logo />

          <nav className="hidden md:flex items-center gap-1">
            <Link to="/" className="btn-ghost" data-testid="nav-home">
              Hem
            </Link>
            <Link to="/search" className="btn-ghost" data-testid="nav-search">
              <Search className="inline w-4 h-4 mr-1" />
              Hitta foton
            </Link>
            <Link to="/sponsring" className="btn-ghost" data-testid="nav-sponsorship">
              Sponsring
            </Link>
            <Link to="/photographer/login" className="btn-ghost" data-testid="nav-photographer">
              <User className="inline w-4 h-4 mr-1" />
              Fotograf
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link to="/cart" className="relative btn-ghost flex items-center gap-2" data-testid="nav-cart">
              <ShoppingBag className="w-4 h-4" />
              <span>Varukorg</span>
              {count > 0 && (
                <span
                  className="absolute -top-1 -right-1 bg-brand text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1"
                  data-testid="cart-count"
                >
                  {count}
                </span>
              )}
            </Link>
            {isLoggedIn() ? (
              <>
                <Link
                  to={role === "admin" ? "/admin" : "/photographer/dashboard"}
                  className="btn-secondary text-sm py-2 px-4"
                  data-testid="nav-dashboard"
                >
                  Dashboard
                </Link>
                <button onClick={logout} className="btn-ghost" data-testid="nav-logout" aria-label="Logout">
                  <LogOut className="w-4 h-4" />
                </button>
              </>
            ) : (
              <Link to="/photographer/register" className="btn-primary text-sm py-2 px-4" data-testid="nav-cta">
                Publicera dina foton
              </Link>
            )}
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-white p-2"
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-white/10 py-4 space-y-2" data-testid="mobile-menu">
            <Link to="/" onClick={() => setOpen(false)} className="block btn-ghost">
              Hem
            </Link>
            <Link to="/search" onClick={() => setOpen(false)} className="block btn-ghost">
              Hitta foton
            </Link>
            <Link to="/sponsring" onClick={() => setOpen(false)} className="block btn-ghost">
              Sponsring
            </Link>
            <Link to="/cart" onClick={() => setOpen(false)} className="block btn-ghost">
              Varukorg ({count})
            </Link>
            <Link to="/photographer/login" onClick={() => setOpen(false)} className="block btn-ghost">
              Fotograf-login
            </Link>
            {isLoggedIn() ? (
              <button onClick={logout} className="block btn-ghost text-left w-full">
                Logga ut
              </button>
            ) : (
              <Link to="/photographer/register" onClick={() => setOpen(false)} className="block btn-primary text-center mx-4">
                Publicera dina foton
              </Link>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
